import React, { useEffect, useState } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { Expert } from './components/Expert';
import { BenefitsAndIncludes } from './components/BenefitsAndIncludes';
import { Bonuses } from './components/Bonuses';
import { SocialProof } from './components/SocialProof';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Button } from './components/Button';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  // Initialize Meta Pixel + fire PageView once on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show floating CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowFloatingCTA(true);
      } else {
        setShowFloatingCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-brand-50 font-sans selection:bg-cta selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSolution data-id="element-3" />
      <Expert data-id="element-4" />
      <BenefitsAndIncludes data-id="element-5" />
      <Bonuses data-id="element-6" />
      <SocialProof data-id="element-7" />
      <Offer data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <Footer data-id="element-11" />

      {/* Floating Mobile CTA */}
      <div className={`
          fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-brand-200 shadow-[0_-10px_30px_rgba(0,0,0,0.1)]
          transform transition-transform duration-300 z-50 md:hidden
          ${showFloatingCTA ? 'translate-y-0' : 'translate-y-full'}
        `} data-id="element-12">
        <Button fullWidth size="lg" onClick={scrollToOffer} data-id="element-13">
          ¡QUIERO EMPEZAR HOY!
        </Button>
      </div>

      {/* Recent purchase social proof toasts */}
      <PurchaseToast data-id="element-14" />
    </div>;
}